import { render, staticRenderFns } from "./IntegrationReportComponents.vue?vue&type=template&id=1c08b0fc&"
import script from "./IntegrationReportComponents.vue?vue&type=script&lang=js&"
export * from "./IntegrationReportComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports